import React from 'react';
import { Svg } from '@marvelapp/ui';
export default function Group() {
    return (React.createElement(Svg, { color: "slate", height: "20", viewBox: "0 0 24 20", width: "24" },
        React.createElement("path", { d: "m22.5 3h-11.264c-.189 0-.362-.107-.447-.276l-.947-1.9c-.255-.507-.774-.827-1.342-.82402091h-7c-.828 0-1.5.67202091-1.5 1.50002091v17c0 .828.672 1.5 1.5 1.5h21c.828 0 1.5-.672 1.5-1.5v-14c0-.828-.672-1.5-1.5-1.5z" })));
}
